import React, { useEffect } from "react";
import { Box, Button, Typography } from "@mui/material";
import { QueryFieldsSelector } from "components/queries/queryBuilder/dialogParts/QueryFieldsSelector";
import { useTranslation } from "react-i18next";
import { DashboardDocument } from "components/resources/dashboards/DashboardDocument";
import DashboardSelectionButtonPreloaded from "components/resources/dashboards/DashboardSelectionButtonPreloaded";
import APIRequest from "system/APIRequest";
import { Add, Folder } from "@mui/icons-material";

export interface TemplateSearchOptionsProps {
  showDashboardSelector?: boolean;

  selectedDashboardOption?: DashboardDocument | undefined;
  setSelectedDashboardOption?: (dashboard: DashboardDocument | undefined) => void;

  onAddNewQuery: () => void;
  onLoadQuery: () => void;

  showAddButtons?: boolean;

}

export default function TemplateSearchOptions(props: TemplateSearchOptionsProps): JSX.Element {
  const { i18n } = useTranslation();
  const {
    showDashboardSelector,
    selectedDashboardOption,
    setSelectedDashboardOption,
    onAddNewQuery,
    onLoadQuery,
    showAddButtons
  } = props;

  useEffect(() => {
    // If we don't have a selected dashboard, load the most recently updated template dashboard
    if (showDashboardSelector && setSelectedDashboardOption && !selectedDashboardOption) {
      const requestOptions:any = {
        "per_page":1,
        "sort":"last_viewed_by_you",
        "sort_order":"desc"
      };
      requestOptions["q"] = JSON.stringify([{"id":"template_type","op":"not-null","value":""}]);

      APIRequest("obj/dashboard", requestOptions).then((response: any) => {
        if (response?.output.length) {
          setSelectedDashboardOption(response.output[0]);
        } else {
          const searchObj = [
            {"id":"global_access","op":"=","value":"1"},
            {"id":"template_type","op":"not-null","value":""}
          ];

          const globalRequestOptions:any = {
            "per_page":1,
            "sort":"last_viewed_by_you",
            "sort_order":"desc",
            "include_shared": 1,
            "q": JSON.stringify(searchObj)
          };

          APIRequest("obj/dashboard", globalRequestOptions).then((response: any) => {
            if (response?.output.length) {
              setSelectedDashboardOption(response.output[0]);
            }
          });
        }
      });
    }
  }, [showDashboardSelector, setSelectedDashboardOption, selectedDashboardOption]);

  return (
    <Box sx={{
        display: 'grid',
        gridTemplateColumns: { xs: "1fr", sm: "auto auto" },
        p: 0, m: 0, pt: 1, pb: 1,
        borderBottom: 1,  borderColor: 'divider' }}>
      <Box sx={{opacity: 0.7 }}>
        {showDashboardSelector && setSelectedDashboardOption &&
          <Typography
            variant="h4" color="textSecondary"
            sx={{ verticalAlign:'middle', pt: 0, pl: 2, pb: 0, pr: 1, display: 'inline-block' }}>
            {i18n.t("widget-types.template-search.label")}:
          </Typography>
        }
        {showDashboardSelector && setSelectedDashboardOption &&
          <DashboardSelectionButtonPreloaded
            selectedDashboard={selectedDashboardOption}
            setSelectedDashboard={setSelectedDashboardOption}
            limitToTemplateDashboards={true}
            size="small"
            variant="text"
          />
        }
      </Box>
      {showAddButtons &&
        <Box sx={{ textAlign: {xs:'left', sm:'right'}, mt: {xs: 1, sm: 0}, mr: 1, ml: {xs: 2, sm: 0} }}>
          <Button
            sx={{ m: 0 }}
            variant="text"
            size='small'
            color='success'
            onClick={onAddNewQuery}
            startIcon={<Add />} >
            {i18n.t('widget-types.template-search.add-query')}
          </Button>
          <Button
            sx={{ m: 0, ml: 1 }}
            size='small'
            variant="text"
            onClick={onLoadQuery}
            startIcon={<Folder />} >
            {i18n.t('widget-types.template-search.load-saved-query')}
          </Button>
        </Box>
      }
    </Box>
  );
}